import axios from 'axios';
import { Language, PresentationType, SSE_ENDPOINTS } from '@constants';
import { PointerPosition, VideoData } from '@actions/types';
import { ConnectionData } from '@types';

const { 
  START, 
  END,
  CONNECTION,
  PRESENTATION_TYPE, 
  SLIDE_ID, 
  PDF_PAGE, 
  SELECT_TERM, 
  LOAN_INPUTS, 
  SHOW_POINTER, 
  POINTER_POSITION, 
  VIDEO, 
  LANGUAGE, 
  STEP, 
  INFO_ITEM,
  SCROLL
} = SSE_ENDPOINTS;

/* Sending updates over the stream */

const triggerServerSentEvent = async (endpoint: string, data: any) => {
  try {
    await axios.put(endpoint, data);
  } catch (err: Error | unknown) {
    console.error(`Error sending ${endpoint} event: ${err instanceof Error ? err.message : JSON.stringify(err) }`);
  }
};

export const sendSlideIdUpdate = async ({ slideId, lastSlideId, presentationId }: { slideId: number, lastSlideId: number, presentationId: number }) => {
  await triggerServerSentEvent(SLIDE_ID, { lastSlideId, slideId, presentationId });
}; 

export const updatePdfPage = async (pageNumber: number) => {
  await triggerServerSentEvent(PDF_PAGE, { pageNumber });
};

export const updatePresentationType = async (presentationType: PresentationType) => {
  await triggerServerSentEvent(PRESENTATION_TYPE, {presentationType});
};

export const updateSelectedTerm = async ({ slideId, term }: { slideId: number, term: number }) => {
  await triggerServerSentEvent(SELECT_TERM, {slideId, term});
};

export const updateConnection = async (leadId: string, data: ConnectionData) => {
  await triggerServerSentEvent(CONNECTION, { leadId, ...data });
};

export const stopEventStreamUpdates = async ({ presentationType, slideId, presentationId }: { presentationType: PresentationType, slideId: number, presentationId: number }) => {
  await triggerServerSentEvent(END, { presentationType, lastSlideId: slideId, presentationId });
};

export const streamPointerPosition = async (pointerPosition: PointerPosition) => {
  await triggerServerSentEvent(POINTER_POSITION, { pointerPosition });
};

export const triggerClientPointer = async (showPointer: boolean) => {
  await triggerServerSentEvent(SHOW_POINTER, { showPointer });
};

export const startPresentation = async (connectionData: ConnectionData) => {
  await triggerServerSentEvent(START, { ...connectionData });
};

export const updateVideoControls = async ({ play, pause }: VideoData) => {
  await triggerServerSentEvent(VIDEO, { videoData: { play, pause } });
};

export const sendLanguageUpdate = async ({ language }: { language: Language }) => {
  await triggerServerSentEvent(LANGUAGE, { language });
};

export const addStepReviewed = async ({ slideId, step }: { slideId: number, step: string }) => {
  await triggerServerSentEvent(STEP, { slideId, step });
};

export const updateInfoItem = async ({ item }: { item: string }) => {
  await triggerServerSentEvent(INFO_ITEM, { infoItem: item });
};

export const updateLoanInputs = async ({ name, value }: { name: string, value: string }) => {
  await triggerServerSentEvent(LOAN_INPUTS, { name, value });
};

export const scrollElement = async ({ elementId, top, left }: { elementId: string, top: number, left: number }) => {
  await triggerServerSentEvent(SCROLL, { elementId, top, left });
};

